// ----------------------------------------------------------------------
import { de } from 'date-fns/locale'

function path(root: string, sublink: string) {
  return `${root}${sublink}`
}

export const ROOTS_PATH = '/'
export const ROOTS_SHRIMP_PRICE = '/shrimp-price'
const ROOTS_AUTH = '/auth'
const ROOTS_DASHBOARD = '/dashboard'
const ROOTS_SETTINGS = '/settings'

export const PATH_POLICY = {
  consent: '/policy-consent',
}

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
  settings: ROOTS_SETTINGS,
}

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/farms'),
    settings: path(ROOTS_DASHBOARD, '/settings'),
    profile: path(ROOTS_DASHBOARD, '/profile'),
    feedback: path(ROOTS_DASHBOARD, '/feedback'),
    changePhone: path(ROOTS_DASHBOARD, '/change-phone'),
    resetPassword: path(ROOTS_DASHBOARD, '/reset-password'),
  },
  admin: {
    root: path(ROOTS_DASHBOARD, '/admin'),
  },
  farms: {
    root: path(ROOTS_DASHBOARD, '/farms'),
    detail: (farmId: string) => path(ROOTS_DASHBOARD, `/farms/${farmId}`),
  },
  members: {
    list: path(ROOTS_DASHBOARD, '/members'),
    roles: path(ROOTS_DASHBOARD, '/members/roles'),
  },
  inventory: {
    category: path(ROOTS_DASHBOARD, '/category'),
    product: path(ROOTS_DASHBOARD, '/product'),
    warehouse: path(ROOTS_DASHBOARD, '/warehouse'),
    stock: path(ROOTS_DASHBOARD, '/stock'),
    settings: path(ROOTS_DASHBOARD, '/inventory/settings'),
    stockEnforcement: path(ROOTS_DASHBOARD, '/inventory/settings/stock-enforcement'),
    displaySettingsFood: path(ROOTS_DASHBOARD, '/inventory/settings/display/food'),
    displaySettingsMedicine: path(ROOTS_DASHBOARD, '/inventory/settings/display/medicine'),
  },
  ponds: {
    root: path(ROOTS_DASHBOARD, '/ponds'),
    detail: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}`),
    dashboard: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/dashboard`),
    food: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/food`),
    growth: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/growth`),
    water: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/water`),
    deadShrimp: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/dead-shrimp`),
    medicine: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/medicine`),
    cost: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/cost`),
    sales: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/sales`),
    transfer: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/transfer`),
    topup: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/topup`),
    setting: (farmId: string, pondId: string) =>
      path(ROOTS_DASHBOARD, `/farms/${farmId}/pond/${pondId}/setting`),
  },
  shrimpPrice: {
    root: path(ROOTS_DASHBOARD, ROOTS_SHRIMP_PRICE),
  },
  comparison: {
    root: path(ROOTS_DASHBOARD, '/comparison'),
  },
  organization: {
    root: path(ROOTS_DASHBOARD, '/organization'),
  },
  notification: {
    root: path(ROOTS_DASHBOARD, '/notifications'),
    setting: path(ROOTS_DASHBOARD, '/notifications/settings'),
  },
  wallet: {
    root: path(ROOTS_DASHBOARD, '/wallet'),
  },
  policy: {
    root: path(ROOTS_DASHBOARD, '/policy'),
  },
  iot: {
    root: path(ROOTS_DASHBOARD, '/iot'),
    create: path(ROOTS_DASHBOARD, '/iot/new'),
    detail: (deviceId: string) => path(ROOTS_DASHBOARD, `/iot/${deviceId}`),
    setting: (deviceId: string) => path(ROOTS_DASHBOARD, `/iot/${deviceId}/setting`),
    threshold: (deviceId: string) => path(ROOTS_DASHBOARD, `/iot/${deviceId}/threshold`),
  },
}
